export const MESSAGE_START_RECORDING = "ts_1";
export const MESSAGE_STOP_RECORDING = "ts_2";
export const MESSAGE_START_MANUAL_EXEC = "ts_60";
export const MESSAGE_SEND_RECORDING = "ts_4";
export const MESSAGE_SEND_RESPONSE = "ts_5";
export const ELEMENT_CREATED = "ELEMENT_CREATED";
export const MESSAGE_GET_ELEMENT = "ts_11";
export const INSTALLED_PING_MESSAGE = "ts_14";
export const INSTALLED_PONG_MESSAGE = "ts_15";
export const MESSAGE_STOP_SPY = "ts_16";
export const MESSAGE_ELEMENT_TYPE = "ts_17";
export const MESSAGE_TYPE_STOPPED_RECORDING = "ts_22";
export const MESSAGE_TYPE_GET_ACTION_STEPS_LIST = "ts_31";
export const MESSAGE_TYPE_DELETE_STEP_BY_ID = "ts_49";
export const MESSAGE_SAVE_ELEMENT_LIST = "ts_42";
export const POST_INSTALLED_PONG_MESSAGE = "ts_50";
export const AUTOPILOT_SERV = "autopilotqa_serv";
export const APQA_TEST_STEPS_ADDED = "APQA_TEST_STEPS_ADDED";
export const GET_CURRENT_WINDOW_ID = "GET_CURRENT_WINDOW_ID";
export const RECORD_ACTION = "RECORD_ACTION";
export const INJECT_FRAME = "INJECT_FRAME";
export const INJECT_EXTERNAL_FRAME = "INJECT_EXTERNAL_FRAME";
export const GET_AUTH_COOKIE = "GET_AUTH_COOKIE";
export const FETCH_NATURAL_TEXT_ACTIONS = "FETCH_NATURAL_TEXT_ACTIONS";
export const FETCH_UI_IDENTIFIER = "FETCH_UI_IDENTIFIER";
export const PUSH_UI_IDENTIFIER = "PUSH_UI_IDENTIFIER";
export const UPDATE_TEST_STEPS = "UPDATE_TEST_STEPS";
export const CREATE_TEST_STEPS = "CREATE_TEST_STEPS";
export const SET_RECORDING_WINDOW_ID = "SET_RECORDING_WINDOW_ID";
export const SET_RECORDING_META_DATA = "SET_RECORDING_META_DATA";
export const ADD_ACTION = "ADD_ACTION";
export const STOP_RECORDING = "STOP_RECORDING";
export const FETCH_TEST_STEPS = "FETCH_TEST_STEPS";
export const HANDLE_BROWSER_EVENT = "HANDLE_BROWSER_EVENT";
export const SET_MOUSE_OVER_ACTIVE = "SET_MOUSE_OVER_ACTIVE";
export const SET_RECORDING_ACTIVE = "SET_RECORDING_ACTIVE";
export const FETCH_TEST_DATA_PROFILE = "FETCH_TEST_DATA_PROFILE";
export const FETCH_TEST_CASE = "FETCH_TEST_CASE";
export const INJECT_MINI_FRAME = "INJECT_MINI_FRAME";
export const INJECT_MINIWIDGET_FRAME = "INJECT_MINIWIDGET_FRAME";
export const INJECT_MAXWIDGET_FRAME = "INJECT_MAXWIDGET_FRAME";
export const FETCH_UI_IDENTIFIER_DETAILS = "FETCH_UI_IDENTIFIER_DETAILS";
export const FETCH_UI_IDENTIFIER_LIST = "FETCH_UI_IDENTIFIER_LIST";
export const ADD_UI_IDENTIFIER_SCREEN_NAME = "ADD_UI_IDENTIFIER_SCREEN_NAME";
export const UPDATE_UI_IDENTIFIER_SCREEN_NAME =
  "UPDATE_UI_IDENTIFIER_SCREEN_NAME";
export const CREATE_UI_IDENTIFIER = "CREATE_UI_IDENTIFIER";
export const TEST_STEPS_BULK_UPDATE = "TEST_STEPS_BULK_UPDATE";
export const STEP_SETTING_BULK_UPDATE = "STEP_SETTING_BULK_UPDATE";
export const FETCH_TEST_CASE_BY_ID = "FETCH_TEST_CASE_BY_ID";
export const STORE_TARGET_ELEMENT = "STORE_TARGET_ELEMENT";
export const CAPTURE_SCREENSHOT = "CAPTURE_SCREENSHOT";
export const INJECT_WIDGET_POPUP = "INJECT_WIDGET_POPUP";
export const FETCH_TEST_STEP_GROUP = "FETCH_TEST_STEP_GROUP";
export const MESSAGE_BUG_CAPTURE = "ts_70";
export const BUG_CAPTURE_PAYLOAD = "BUG_CAPTURE_PAYLOAD";
export const MESSAGE_START_SESSION_RECORDING = "ts_71";
export const MESSAGE_STOP_SESSION_RECORDING = "ts_72";
